export const CONTROL_RESPONSE_ERROR_KEY = 'responseError';
export const SETTINGS_FORM_GROUP_NAME = 'settings';
